<div class="slider">
    <!-- Tick labels -->
    <div class="tick-labels">
        <div class="tick" *ngFor="let value of labels" [style.left.%]="((value - min) / (max - min)) * 100">
            {{ value }}
        </div>
    </div>
    <!-- Slider: use --p CSS var so gradient fill reflects current percent -->
    <input type="range" class="pd-slider readonly" [attr.min]="min" [attr.max]="max" [attr.step]="step"
        [ngModel]="sliderValue" [style.--p.%]="percent" aria-label="Total Professional Development Hours" />
</div>
<!-- <form [formGroup]="sliderForm" class="slider-wrap">
    <label class="field-label" for="">Total Professional Development Hours</label> -->
    <!-- Number input bound to the same FormControl -->
    <!-- <input class="value-box" type="number" formControlName="hours" [min]="min" [max]="max" [step]="step" /> -->
    <!-- error message for min and max values -->
    <!-- <div class="error" *ngIf="sliderForm.controls['hours'].touched">
        <small>{{getErrors()}}</small>
    </div>
</form> -->